import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=9f530b9a&scoped=true"
import script from "./Setup.vue?vue&type=script&lang=js"
export * from "./Setup.vue?vue&type=script&lang=js"
import style0 from "./Setup.vue?vue&type=style&index=0&id=9f530b9a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f530b9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f530b9a')) {
      api.createRecord('9f530b9a', component.options)
    } else {
      api.reload('9f530b9a', component.options)
    }
    module.hot.accept("./Setup.vue?vue&type=template&id=9f530b9a&scoped=true", function () {
      api.rerender('9f530b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Setup.vue"
export default component.exports